<template>
  <div>
    <v-container fluid>
      <date-filter v-model="selectedDate" @changeDate="onDateChanged" :default-filter="'today'"></date-filter>
    </v-container>
    <v-container class="pb-9" style="padding-bottom: 90px !important;">
      <v-data-table
        :rows-per-page-items="[25, 40, 50, 100]"
        :loading="loading"
        :headers="headers"
        :items="items"
        class="elevation-1"
      >
        <template v-slot:items="props">
          <tr>
            <td class="text-xs-left">{{ props.item.timestamp | dateFormat('DD/MM/YYYY HH:mm') }}</td>
            <td class="text-xs-left">{{ props.item.adminmessage }}</td>
            <td class="text-xs-left">{{ props.item.vulgarity }}</td>
            <td class="text-xs-left">{{ props.item.adminname }}</td>
            <td class="test-xs-left">
              <v-btn
                :href="'https://business.facebook.com' + props.item.inboxurl"
                target="_blank"
                small
                :disabled="!props.item.inboxurl"
                depressed
                round
                color="#3b5998"
                :dark="props.item.inboxurl?true:false"
              >
                <i class="fab fa-facebook-square mr-1"></i>
                {{$t('View inbox')}}
              </v-btn>
            </td>
            <td class="text-xs-center" style="white-space: nowrap;">
              <div v-if="props.item.qa == null">
                <v-btn
                  depressed
                  :disabled="loadingBtn == props.item.id"
                  :loading="loadingBtn == props.item.id"
                  @click="qaUpdate(props.item,true)"
                  color="#55d85b"
                  small
                  style="color: white;width: 3.5em;min-width: 0;"
                >
                  <i class="fas fa-check"></i>
                </v-btn>
                <v-btn
                  depressed
                  :disabled="loadingBtn == props.item.id"
                  :loading="loadingBtn == props.item.id"
                  @click="qaUpdate(props.item,false)"
                  color="#ff7166"
                  small
                  style="color: white;width: 3.5em;min-width: 0;"
                >
                  <i class="fas fa-times"></i>
                </v-btn>
              </div>
              <div v-else>
                <div
                  v-if="props.item.qa"
                  @click="props.item.qa = null"
                  style="color: #55d85b; font-weight: 600; cursor: pointer"
                >
                  ผ่าน
                  <i style="color: grey" class="fas fa-pencil-alt"></i>
                </div>
                <div
                  v-else
                  @click="props.item.qa = null"
                  style="color: #ff7166; font-weight: 600; cursor: pointer"
                >
                  ไม่ผ่าน
                  <i style="color: grey" class="fas fa-pencil-alt"></i>
                </div>
              </div>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-container>
  </div>
</template>

<script>
import DateFilter from './DateFilter.vue'
import dayjs from 'dayjs'
import api from '@/api'
import { mapGetters } from 'vuex'
export default {
  components: {
    DateFilter
  },
  data() {
    return {
      data: '',
      selectedDate: {
        start: dayjs().format('YYYY-MM-DD'),
        end: dayjs().format('YYYY-MM-DD')
      },
      headers: [
        { text: 'เวลา', value: 'time', align: 'center' },
        { text: 'ข้อความแอดมิน', value: 'Admin_text' },
        { text: 'คำหยาบที่ลูกค้าพิมพ์', value: 'vulgarity' },
        { text: 'ชื่อแอดมินที่พิมพ์', value: 'Admin_name' },
        { text: '', value: '' },
        { text: 'QA', value: 'qa', align: 'center', sortable: false }
      ],
      items: [],
      loading: true,
      loadingBtn: ''
    }
  },
  mounted() {
    this.getastonqaadminchatlog()
  },
  computed: {
    ...mapGetters(['selectedBot'])
  },
  methods: {
    openPopUp(url) {
      window.open(
        url,
        '_blank',
        'toolbar=yes,scrollbars=yes,resizable=yes,top=0,width=1000,height=900'
      )
    },
    getastonqaadminchatlog() {
      this.loading = true
      api.getastonqaadminchatlog(
        {
          datefrom: this.selectedDate.start,
          dateto: this.selectedDate.end,
          pageid: this.selectedBot.pageid
        },
        (error, response) => {
          this.items = response.data
          this.loading = false
        }
      )
    },
    onDateChanged() {
      this.getastonqaadminchatlog()
    },
    qaUpdate(item, qa) {
      this.loadingBtn = item.id
      api.putastonqaadminchatlog(
        { id: item.id, userid: item.userid, timestamp: item.timestamp, qa },
        (err, response) => {
          if (response.responsecode == 200) {
            this.loadingBtn = ''
            item.qa = qa
          }
        }
      )
    }
  }
}
</script>


<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/view/dashboard/AstonDashboardAdminMessage.vue